export const BOOK_READER_SET_LOADING = "BOOK_READER_SET_LOADING";
export const BOOK_READER_SET_ERROR = "BOOK_READER_SET_ERROR";
export const BOOK_READER_SET_BOOKS = "BOOK_READER_SET_BOOKS";
export const BOOK_READER_SET_CURRENT_BOOK = "BOOK_READER_SET_CURRENT_BOOK";
export const BOOK_READER_UPDATE_BOOK = "BOOK_READER_UPDATE_BOOK";
export const BOOK_READER_CHAT_STREAM_CHUNK = "BOOK_READER_CHAT_STREAM_CHUNK";
export const BOOK_READER_CHAT_STREAM_DONE = "BOOK_READER_CHAT_STREAM_DONE";
export const BOOK_READER_CHAT_RESET = "BOOK_READER_CHAT_RESET";
export const BOOK_READER_RESET = "BOOK_READER_RESET";

export const BOOK_READER_REMOVE_BOOK = "BOOK_READER_REMOVE_BOOK";

export const BOOK_READER_CHAT_ADD_USER_MSG = "BOOK_READER_CHAT_ADD_USER_MSG";
export const BOOK_READER_CHAT_FINALIZE_ASSISTANT = "BOOK_READER_CHAT_FINALIZE_ASSISTANT";
export const BOOK_READER_CHAT_VOICE_TRANSCRIPTION = "BOOK_READER_CHAT_VOICE_TRANSCRIPTION";

export const BOOK_READER_SET_CURRENT_CHAT_ID = "BOOK_READER_SET_CURRENT_CHAT_ID";
export const BOOK_READER_CHAT_LOAD_MESSAGES = "BOOK_READER_CHAT_LOAD_MESSAGES";
export const BOOK_READER_CLEAR_CHAT_SESSION = "BOOK_READER_CLEAR_CHAT_SESSION";
export const BOOK_READER_SET_CHAT_LIST = "BOOK_READER_SET_CHAT_LIST";
export const BOOK_READER_CHAT_UPSERT_LIST_ITEM = "BOOK_READER_CHAT_UPSERT_LIST_ITEM";
